import Validator, { ValidatedValue, ValidatorModel } from "./validator";
import { ErrorMessages } from "./errorMessage";
import { AddressClass, AddressModel } from "./address";
import { makeObservable, observable } from "mobx";

export interface CessionBankModel {
  cessionSelected: boolean;
  bankName: ValidatedValue<string>;
  bankNameContinuation: ValidatedValue<string>;
  address: AddressModel;
  regon: ValidatedValue<string>;
  nip: ValidatedValue<string>;

  reset: () => void;
  validate: () => void;
}

const cessionBankValidators: ValidatorModel = {
  bankName: [
    { name: "bankNameIsNotEmpty", fn: Validator.isNotEmpty, errorMessage: ErrorMessages.required }
  ],
  regon: [
    { name: "regonIsNotEmpty", fn: Validator.isNotEmpty, errorMessage: ErrorMessages.required },
    { name: "regonIsValid", fn: Validator.regon, errorMessage: ErrorMessages.client.regon }
  ],
  nip: [
    { name: "nipIsNotEmpty", fn: Validator.isNotEmpty, errorMessage: ErrorMessages.required },
    { name: "nipIsValid", fn: Validator.nip, errorMessage: ErrorMessages.client.nip }
  ]
};

export interface CessionBankArguments {
  cessionSelected: boolean;
  bankName?: string;
  bankNameContinuation?: string;
  address?: AddressModel;
  nip?: string;
  regon?: string;
}

export class DefaultCessionBank implements CessionBankModel {
  @observable cessionSelected = false;
  @observable bankName: ValidatedValue<string> = new ValidatedValue("", cessionBankValidators.bankName);
  @observable bankNameContinuation: ValidatedValue<string> = new ValidatedValue("");
  @observable address: AddressModel = AddressClass.default();
  @observable nip: ValidatedValue<string> = new ValidatedValue("", cessionBankValidators.nip);
  @observable regon: ValidatedValue<string> = new ValidatedValue("", cessionBankValidators.regon);

  constructor(args?: CessionBankArguments) {
    makeObservable(this);

    this.cessionSelected = args?.cessionSelected ?? false;
    this.bankName.value = args?.bankName ?? "";
    this.bankNameContinuation.value = args?.bankNameContinuation ?? "";
    this.address = args?.address ?? AddressClass.default();
    this.nip.value = args?.nip ?? "";
    this.regon.value = args?.regon ?? "";
  }

  validate(): void {
    if (this.cessionSelected) {
      this.bankName.validate();
      this.address.validate();
      this.nip.validate();
      this.regon.validate();
    }
  }

  reset(): void {
    this.cessionSelected = false;
    this.bankName.value = "";
    this.bankNameContinuation.value = "";
    this.address = AddressClass.default();
    this.nip.value = "";
    this.regon.value = "";
  }
}
